import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      setAdminToken(res.data.token);
      toast.success("Benvenuto");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Password errata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-primary flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-2xl">
        <div className="w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center mb-6">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display text-4xl text-primary mb-2">Area riservata</h1>
        <p className="text-muted-foreground mb-8">
          Accesso gestionale · Hotel Due Pini Conte
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              required
            />
          </div>
          <Button
            data-testid="admin-login-submit"
            type="submit"
            className="btn-primary pill w-full"
            disabled={loading}
          >
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Accedi
          </Button>
        </form>
      </div>
    </div>
  );
}
